import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-comp",
  "use": "dv-comp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-comp\"><defs><style>#dv-comp .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 11</title><g id=\"dv-comp_图层_2\" data-name=\"图层 2\"><g id=\"dv-comp_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-comp_矩形_273\" data-name=\"矩形 273\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"dv-comp_组_2471\" data-name=\"组 2471\"><path id=\"dv-comp_路径_1253\" data-name=\"路径 1253\" d=\"M20 11.39h-1.2V7.68a2.48 2.48 0 0 0-2.47-2.47h-3.71V4a2.47 2.47 0 1 0-4.94 0v1.21H4a2.47 2.47 0 0 0-2.5 2.46v3.71h1.24a2.47 2.47 0 0 1 0 4.94H1.5V20A2.48 2.48 0 0 0 4 22.5h3.68v-1.23a2.47 2.47 0 0 1 4.94 0v1.23h3.7a2.48 2.48 0 0 0 2.47-2.5v-3.7H20a2.47 2.47 0 1 0 0-4.94z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-comp.svg
// module id = euQT
// module chunks = 6